import styled from 'styled-components'

import theme from '~/truck/theme'

export const Container = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: ${theme.spacing.comfortable}px;

  > svg {
    height: ${theme.spacing.comfortable}px;
    width: ${theme.spacing.comfortable}px;
  }

  > :not(:last-child) {
    margin-right: ${theme.spacing.cozy}px;
  }
`
